import { useEffect } from 'react';
import { UseFormSetError, UseFormClearErrors, FieldValues } from 'react-hook-form';
import { validateBarcode } from 'src/services/utility';
import { useTranslation } from 'react-i18next';

interface UseBarcodeValidationProps<T extends FieldValues> {
  barcode: string;
  fieldPath: string;
  setError: UseFormSetError<T>;
  clearErrors: UseFormClearErrors<T>;
}

export const useBarcodeValidation = <T extends FieldValues>({
  barcode,
  fieldPath,
  setError,
  clearErrors,
}: UseBarcodeValidationProps<T>) => {
  const { t } = useTranslation();

  useEffect(() => {
    const validateBarcodeValue = async () => {
      if (!barcode) return;

      try {
        const response = await validateBarcode(barcode);
        if (!response?.valid) {
          setError(fieldPath as any, { message: t('errors.invalid_barcode') });
        } else {
          clearErrors(fieldPath as any);
        }
      } catch (error) {
        console.error(error);
      }
    };

    validateBarcodeValue();
  }, [barcode, fieldPath, setError, clearErrors, t]);
};
